// Section 17: the priority group registry, plus the catch-all 'everyone-else'.
import type { Config } from '../../config';
import { checkRegistryKeys, type PriorityGroupDef } from '../../core/registry';
import type { PriorityGroupId } from '../../core/types';
import { builders } from './builders';
import { children6To14 } from './children-6-14';
import { childrenUnder6 } from './children-under-6';
import { elders } from './elders';
import { everyoneElse } from './everyone-else';
import { farmers } from './farmers';
import { foodProducers } from './food-producers';
import { founders } from './founders';
import { guards } from './guards';
import { healers } from './healers';
import { idleAdults } from './idle-adults';
import { myHousehold } from './my-household';
import { newcomers } from './newcomers';
import { otherWorkers } from './other-workers';
import { pregnant } from './pregnant';
import { sickOrInjured } from './sick-or-injured';
import { teachers } from './teachers';
import { toolmakers } from './toolmakers';
import { waterCarriers } from './water-carriers';

/** Build the priorityGroups registry for a config (content numbers come from the config, ADR-0008). */
export function buildPriorityGroups(config: Config) {
  const priorityGroups = Object.freeze({
    farmers: farmers(config),
    'food-producers': foodProducers(config),
    'water-carriers': waterCarriers(config),
    builders: builders(config),
    toolmakers: toolmakers(config),
    healers: healers(config),
    teachers: teachers(config),
    guards: guards(config),
    'other-workers': otherWorkers(config),
    pregnant: pregnant(config),
    'children-under-6': childrenUnder6(config),
    'children-6-14': children6To14(config),
    elders: elders(config),
    'sick-or-injured': sickOrInjured(config),
    newcomers: newcomers(config),
    founders: founders(config),
    'idle-adults': idleAdults(config),
    'my-household': myHousehold(config),
    'everyone-else': everyoneElse(config),
  } satisfies Record<PriorityGroupId, PriorityGroupDef>);
  checkRegistryKeys('priorityGroups', priorityGroups);
  return priorityGroups;
}
